module.exports = __webpack_public_path__ + "media/index7.fa64ae9b.webm";